/**
 *
 * Asynchronously loads the component for ShapeSquare
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShapeSquare = lazyLoad(
  () => import('./index'),
  module => module.ShapeSquare,
);
